<!-- 汇率查询 -->
<template>
  <div class="orderSearch">
    <sirui-search
      ref="siruiSearch"
      :query="searchForm"
      :columns="searchColumns"
      @searchCompanyChange="searchCompanyChange"
      @resetBtnClick="resetBtnClick"
      @searchBtnClick="searchBtnClick"
    >
    </sirui-search>
    <!-- 表格 -->
    <div class="main-content">
      <vxe-toolbar v-if="menuButtonList && menuButtonList.length > 0">
        <template v-slot:buttons>
          <template v-for="item in menuButtonList">
            <vxe-button
              type="primary"
              :icon="item.attributes.buttonStyle"
              :style="
                'background-color:' +
                (item.label == '删除' || item.label == '禁用' ? '#FE8783' : 'rgb(98, 153, 254)') +
                ';border:1px solid ' +
                (item.label == '删除' || item.label == '禁用' ? '#FE8783' : 'rgb(98, 153, 254)')
              "
              :key="item.id"
              @click="chooseClick(item.attributes.buttonUrl, item)"
              >{{ item.label }}</vxe-button
            >
          </template>
        </template>
      </vxe-toolbar>
      <vxe-grid
        border
        show-overflow
        resizable
        ref="table"
        class="vxe-table-element"
        size="mini"
        align="left"
        min-width="120"
        :loading="loading"
        :auto-resize="true"
        :data="tableData"
        :columns="columnList"
        :max-height="$store.state.app.tableHeight"
        @select-change="handleSelectionChange"
        @select-all="handleSelectionChange"
        :show-footer="showFooter"
        :footer-method="footerMethodTotal"
      >
      </vxe-grid>
      <!-- 分页 -->
      <div class="pagination">
        <el-pagination
          ref="page"
          background
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="page.pageNum"
          :page-sizes="[10, 20, 50, 100]"
          :page-count="page.pages"
          :page-size="page.pageSize"
          :total="page.total"
          layout="total, sizes, prev, pager, next, jumper"
        ></el-pagination>
      </div>
    </div>
  </div>
</template>

<script>
  import { mapState } from 'vuex';
  import API from '@/api/capitalCenter/moneyDraw';
  import SiruiSearch from '@/components/SiruiSearch';
  import XEUtils from 'xe-utils';
  import baseUrl from '@/common/config';
  export default {
    name: 'orderSearch',
    components: {
      SiruiSearch,
    },
    props: ['searchColumns', 'searchForm', 'columnList', 'api', 'showFooter', 'footerTotalCols'],
    computed: {
      ...mapState({
        userInfo: (state) => state.userInfo.userInfo,
      }),
      token() {
        return {
          access_token: this.userInfo.access_token,
          companyCode: this.userInfo.companyCode,
          companyName: this.userInfo.companyName,
          departmentCode: this.userInfo.departmentCode,
          departmentName: this.userInfo.departmentName,
          tenantCode: this.userInfo.tenantCode,
        };
      },
      exportAction() {
        return API[this.api.export];
      },
    },
    data() {
      return {
        menuButtonList: [], // 按钮
        loading: false,
        tableData: [],
        multipleSelection: [],
        page: {
          pages: 0,
          pageSize: 10,
          pageNum: 1,
          total: 0,
        },
      };
    },
    mounted() {
      if (Object.keys(this.$route.query).length == 0) {
        this.getData();
      }
      this.getButtonList();
    },
    methods: {
      async getData() {
        this.loading = true;
        const { pageNum, pageSize } = this.page;
        let params = { ...this.searchForm, pageNum, pageSize };
        if (params.interestGroupCodes && XEUtils.isArray(params.interestGroupCodes))
          params.interestGroupCodes = params.interestGroupCodes.join(',');
        let res = await this.$axios.post(API[this.api.query], params);
        if (res) {
          this.loading = false;
          if (res.data.code === 0) {
            this.tableData = res.data.data.records;
            this.page.total = res.data.data.total;
            this.updateData();
          }
        }
      },
      updateData() {
        let xTable = this.$refs.table;
        xTable.updateData();
      },
      chooseClick(value) {
        if (value == 'export') {
          this.handleExport();
        }
      },
      handleExport() {
        // 导出
        if (this.tableData.length == 0) {
          return this.$message({
            showClose: true,
            message: this.$t('message.noExport'),
            type: 'error',
          });
        }
        const selectedList = this.$refs.table.getCheckboxReserveRecords(); // 历史选中数据
        let changeList = this.multipleSelection.concat(selectedList);
        if (changeList.length > 0) {
          let str = '';
          changeList.forEach((item) => {
            str += 'ids=' + item.id + '&';
          });
          window.location.href = `${baseUrl}${this.exportAction}?${str}access_token=${this.token.access_token}`;
        } else {
          let params = XEUtils.clone(this.searchForm, true);
          if (params.interestGroupCodes && XEUtils.isArray(params.interestGroupCodes))
            params.interestGroupCodes = params.interestGroupCodes.join(',');
          params = XEUtils.serialize(params);
          window.location.href = `${baseUrl}${this.exportAction}?${params}&access_token=${this.token.access_token}`;
        }
      },
      searchCompanyChange(val) {
        this.$emit('searchCompanyChange', val);
      },
      //获取菜单按钮
      getButtonList() {
        this.getButtons().then((res) => {
          this.menuButtonList = res;
        });
      },
      // 选中事件
      handleSelectionChange(val) {
        this.multipleSelection = val.selection;
      },
      searchBtnClick() {
        this.resetBtnClick();
      },
      resetBtnClick() {
        // 重置
        this.page.pages = 0;
        this.page.pageSize = 10;
        this.page.pageNum = 1;
        this.page.total = 0;
        this.getData();
      },
      handleSizeChange(value) {
        this.page.pageSize = value;
        this.getData();
      },
      handleCurrentChange(value) {
        this.page.pageNum = value;
        this.getData();
      },
      // 通用底部合计总数 - footerTotalCols定义在各个具体文件中，示例如下
      // footerTotalCols:{amount:['contractTotalAmount'],quantity:['productQuantity']}, //底部合计列-字段名，数字类型（金额amount，数量quantity等）判断小数点

      footerMethodTotal({ columns, data }) {
        return [
          columns.map((column, columnIndex) => {
            if (columnIndex === 0) {
              return '合计';
            }
            for (let key in this.footerTotalCols) {
              if (this.footerTotalCols[key].includes(column.property)) {
                let total = XEUtils.calSum(data, column.property);
                let point = this.$globalVar.aPoint;
                if (key == 'quantity') {
                  point = this.$globalVar.qPoint;
                }
                total = XEUtils.commafy(XEUtils.toNumber(total).toFixed(point), point);
                return total;
              }
            }
          }),
        ];
      },
    },
  };
</script>
